import { Digtective } from '..';
import { DiggerFieldType, SubmitInput } from '../context/types';

export function getCustomFields(facade: Digtective, input: SubmitInput) {
  const { zip } = input ?? {};
  const customFields: { [key in DiggerFieldType]?: string } = {};
  if (zip) customFields[DiggerFieldType.Zipcode] = zip;
  return customFields;
}
